<template>
  <div class="propertyInfo">
    <figure>
      <b-img v-if="!this.showImageDefaultImage" height="119px" :src="propertyImage" fluid alt="Logo"></b-img>
      <b-img v-else-if="this.$store.getters.nuvo2026R1LogoToggle" :src="require('@/assets/PoweredByRuckus.png')" fluid alt="RuckusLogo"></b-img>
      <b-img v-else :src="require('@/assets/cs_ruckus_logo.png')" fluid alt="RuckusLogo"></b-img>
    </figure>
    <h4  v-if="this.$store.getters.getPropertyConfigurationInfo.tenantSubtitle !== ''">{{this.$store.getters.getPropertyConfigurationInfo.tenantSubtitle}}</h4>
    <p>{{this.$store.getters.getUnitContactName}}</p>
  </div>
</template>

<script>
import store from "../store/store";
import axios from 'axios';

export default {
  name: 'WelcomeTopView',
  data: () => ({
    //Empty image file here.
    propertyImage: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
    showImageDefaultImage: false,
  }),
  async mounted(){
    if (!store.getters.getIsLoggedIn) {
      return
    }
    await store.dispatch("loadPropertyConfigurationInfo")
    await store.dispatch("loadPropertyInfo")
    await store.dispatch("loadAnnouncements")
    await this.getPropertyImage();
  },
  methods: {
    async getPropertyImage(){
      axios
            .get(location.origin.toString() + "/residents/properties/" +
                          store.getters.getPropertyGuid + "/files/logo",
                          {headers: {Authorization: store.getters.getJwtAuthenticationToken} ,
                            responseType: 'arraybuffer'})
          .then(response => {
            if(response.data === undefined) {
              this.propertyImage = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
            }
            else {
              let image = btoa(
                  new Uint8Array(response.data)
                      .reduce((data, byte) => data + String.fromCharCode(byte), '')
              );
              this.propertyImage = `data:${response.headers['content-type'].toLowerCase()};base64,${image}`;
            }
          })
          .catch(error => {
            if (error.response.status !== 404) {
              console.log("Unexpected error when getting empty logo file: " + error)
            }
            this.showImageDefaultImage = true;
            this.propertyImage =  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
          })

    }
  }
}
</script>

